// Service Worker Registration
export function register() {
  // ✅ ADD: Log that function was called
  console.log('[SW] register() function called');
  console.log('[SW] NODE_ENV check:', process.env.NODE_ENV);
  console.log('[SW] NODE_ENV === "production":', process.env.NODE_ENV === 'production');
  
  // ✅ CRITICAL: Only register in production
  if (process.env.NODE_ENV !== 'production') {
    console.log('❌ Service worker disabled in development mode');
    console.log('[SW] NODE_ENV value:', process.env.NODE_ENV);
    return;
  }

  console.log('[SW] Proceeding with registration...');
  console.log('[SW] serviceWorker in navigator:', 'serviceWorker' in navigator);

  if ('serviceWorker' in navigator) {
    // ✅ CHANGE: Don't wait for 'load' event - register immediately
    // The 'load' event might have already fired
    const publicUrl = process.env.PUBLIC_URL || '';
    const swUrl = publicUrl 
      ? `${publicUrl}/service-worker.js` 
      : '/service-worker.js';
    
    console.log('[SW Registration] Attempting to register:', swUrl);
    console.log('[SW Registration] PUBLIC_URL:', process.env.PUBLIC_URL);
    console.log('[SW Registration] NODE_ENV:', process.env.NODE_ENV);

    // ✅ FIX: Register immediately, don't wait for load event
    navigator.serviceWorker
      .register(swUrl)
      .then((registration) => {
        console.log('✅ SW registered successfully:', registration);
        console.log('Scope:', registration.scope);
        console.log('Active:', registration.active?.state);

        // Check for updates every hour
        setInterval(() => {
          registration.update();
        }, 60 * 60 * 1000);

        // Handle updates
        registration.addEventListener('updatefound', () => {
          const newWorker = registration.installing;
          if (newWorker) {
            newWorker.addEventListener('statechange', () => {
              if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
                // New service worker available
                if (window.confirm('New version available! Reload to update?')) {
                  window.location.reload();
                }
              }
            });
          }
        });
      })
      .catch((error) => {
        console.error('❌ SW registration failed:', error);
        console.error('Error message:', error.message);
        console.error('Error stack:', error.stack);
      });
  } else {
    console.warn('⚠️ Service workers not supported in this browser');
  }
}

export function unregister() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready
      .then((registration) => {
        registration.unregister();
      })
      .catch((error) => {
        console.error(error.message);
      });
  }
}